// client/components/OntologyFilters.tsx
// Filter controls for provider and match type

import React from 'react';
import type { OntologyFilters as FilterType } from '../utils/ontologyFilters';

type Props = {
  filters: FilterType;
  onChange: (filters: FilterType) => void;
};

export function OntologyFilters({ filters, onChange }: Props) {
  const handleProviderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({
      ...filters,
      provider: e.target.value as FilterType['provider'],
    });
  };

  const handleMatchTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({
      ...filters,
      matchType: e.target.value as FilterType['matchType'],
    });
  };

  return (
    <div className="ontology-filters">
      <div className="filter-group">
        <label htmlFor="provider-filter">Provider:</label>
        <select
          id="provider-filter"
          value={filters.provider}
          onChange={handleProviderChange}
        >
          <option value="all">All Providers</option>
          <option value="local">Local (YAML)</option>
          <option value="ols">OLS</option>
          <option value="bioportal">BioPortal</option>
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="matchtype-filter">Match Type:</label>
        <select
          id="matchtype-filter"
          value={filters.matchType}
          onChange={handleMatchTypeChange}
        >
          <option value="all">All Matches</option>
          <option value="Exact">Exact</option>
          <option value="Fuzzy">Fuzzy</option>
          <option value="None">None (Unmapped)</option>
        </select>
      </div>

      <button
        className="reset-filters"
        onClick={() => onChange({ provider: 'all', matchType: 'all' })}
        disabled={filters.provider === 'all' && filters.matchType === 'all'}
      >
        Reset Filters
      </button>
    </div>
  );
}
